import { render } from "./BookList.vue?vue&type=template&id=04ddd668&scoped=true&ts=true"
import script from "./BookList.vue?vue&type=script&lang=ts"
export * from "./BookList.vue?vue&type=script&lang=ts"

import "./BookList.vue?vue&type=style&index=0&id=04ddd668&scoped=true&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ddd668"]])

export default __exports__